import * as React from "react";
import SectionHeading from "src/components/general/SectionHeading";
import Loading from "src/components/general/Loading";
import StackedProgressBar from "./StackedProgressBar";
import { connect } from "react-redux";
import { defaultYear } from "src/constants/ApiSettings";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";

class RevenueBreakdown extends React.PureComponent<
  IConnectedModuleProps,
  IConnectedModuleState,
  ICouncilIdentityBadge
> {
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    this.state = { selectedYear };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
  };

  public render() {
    // this.generateTraces();
    const selectedCouncils = this.props.councils;
    return (
      <div className="w-full" id="revenueBD">
        <SectionHeading
          heading="Here's how your council's revenue is broken down"
          alignment="left"
          yearPicker={ this.handleYearChange }
          year={ this.state.selectedYear }
          learnMore={ "revenueBreakdown" }
          councilSays={ "revenueBreakdownCouncilSays" }
          inverse={ false }
        />

        <div className="block flex lg:hidden text-xs font-bold">
          <div className="c-progressbar-header w-1/3 text-cct-chart-blue-dark" data-heading="Rates & Charges" />
          <div className="c-progressbar-header w-1/3 text-center text-cct-chart-blue-light" data-heading="Operational Grants" />
          <div className="c-progressbar-header w-1/3 text-right text-cct-chart-green" data-heading="Contract Works" />
        </div>

        {selectedCouncils.map((council, index) => {
          if (!council) {
            return <Loading key={0} />;
          }
          return (
            <div className="c-council-progressbar" key={ index }>
              <div className="mt-5  mb-2  lg:mb-5">
                <CouncilIdentityBadge 
                  name={ council.name }
                  badge={ index + 1 }
                  modifier="justify-left"
                />
              </div>
              <StackedProgressBar
                council={ council }
                selectedYear={ this.state.selectedYear }
              />
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,
  
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RevenueBreakdown);



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/RevenueBreakdown.tsx